import axios from "@/services/axios.config";
import { toastOnError } from "@/utils/toastOnError";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export enum FileType {
	METHODOLOGY_ADDITIONAL_INFO = "METHODOLOGY_ADDITIONAL_INFO",
}

interface DeletePublicCommentPayload {
	methodologyId: number;
	additionalInfoId: number;
}

const deletePublicCommentFile = async (payload: DeletePublicCommentPayload) => {
	const url = `/methodology/file?methodologyId=${payload.methodologyId}&additionalInfoId=${payload.additionalInfoId}&fileType=${FileType.METHODOLOGY_ADDITIONAL_INFO}`;
	return axios.delete(url);
};

export default function useDeletePublicCommentFile() {
	const queryClient = useQueryClient();

	return useMutation(deletePublicCommentFile, {
		onSuccess: () => {
			toast.success("Public comment file deleted successfully!");
			queryClient.invalidateQueries({
				queryKey: ["getAdditionalInfo"],
			});
		},
		onError: (err: APIResponse) => {
			toastOnError(err);
		},
	});
}
